export const MAXPAY_OUT = {
    eventAction: ['link click', 'rendered', 'expanded'],
    eventLabel: ['quick bet', 'betslip', 'bet receipt', 'my bets'],
    eventCategory: 'maximum returns',
    trackEvent: 'trackEvent',
};
